<template>
  <v-layout row wrap align-start align-content-start class="mb-2">
    <!-- Title and Actions -->
    <v-flex xs12 class="py-0">
      <v-toolbar color="secondary" class="elevation-0">
        <v-icon class="mr-0 indigo--text text--lighten-5">gavel</v-icon>
        <v-toolbar-title class="white--text subheading ttu">
          <router-link :to="{ name: 'MetadataRulesSearch' }" class="white--text link dim">
            {{ messages.label.METADATA_RULES }}</router-link>
          / {{ messages.label.XPATH_MAPPING }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="accent" flat @click="showAddMapping">
          <v-icon left>add_circle</v-icon><span>{{ messages.label.ADD_MAPPING }}</span>
        </v-btn>
      </v-toolbar>
    </v-flex>
    <v-layout>
      <!-- XPath Mappings List -->
      <v-flex xs8>
        <XPathMappingsList />
      </v-flex>
      <!-- XPath Mapping Details Sheet -->
      <v-flex xs4 class="side-sheet-container mr-2">
        <XPathDetails />
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import XPathMappingsList from "@/MetadataRules/XpathMapping/XPathMappingsList"
import XPathDetails from "@/MetadataRules/XpathMapping/XPathDetails"
import MetadataRulesService from "@/MetadataRules/MetadataRulesService"
import messages from "@/MetadataRules/messages.json"
import AppService from "@/AppService"

export default {
  name: "XPathMappingHome",
  components: {
    XPathMappingsList,
    XPathDetails
  },
  data() {
    return {}
  },
  methods: {
    /**
     * Display side sheet to add a new provider group
     */
    showAddMapping() {
      MetadataRulesService.$emit("event:showXPathMappingDetailsSheet")
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
     * Events
     * */
    AppService.$on("event:preIngestServerError", () => {
      this.snackbar.show = true
      this.snackbar.color = "error"
      this.snackbar.message = this.messages.error.SERVER_ERROR
    })
  }
}
</script>

<style lang="scss">
.side-sheet-container {
  align-self: stretch;
}
</style>



// WEBPACK FOOTER //
// src/MetadataRules/XpathMapping/XPathMappingHome.vue